<template>
  <vs-tooltip text="Export XLSX" position="top">
    <vs-button
      radius
      class="mr-2"
      color="#333f50"
      type="flat"
      @click="exportXLSX"
      icon="cloud_download"
    ></vs-button
  ></vs-tooltip>
</template>

<script>
import moment from "moment";
import XLSX from "xlsx"; // import xlsx
import html2pdf from "html2pdf.js";
import jsPDF from "jspdf";
import "jspdf-autotable";
export default {
  props: {
    dataList: Array,
    headerName: String,
    header: Array,
  },
  data: () => ({
    nwlist: [],
    headerName: "",
    i: "",
    dataList: [],
    selectFilter: [],
    d: "",
    network: "",
    role: "",
    a: [],
    filter_input: [
      {
        alertname: "",
        message: "",
        sensorname: "",
        lastdata: "",
        timestamp: "",
        alertstatus: "",
      },
    ],
    filter_list: [],
    primeTable: "",
    finds: [],
    counter: 0,
    dataBody: [],
    dataExport: [],
    dataActive: "",
  }),
  methods: {
    // exportPDF
    exportXLSX() {
      console.log(this.headerName);
      switch (this.headerName) {
        case "Sensor":
          this.dataList.forEach((element) => {
            if (element.active == "1") {
              this.dataActive = "Active";
            }
            if (element.active == "0") {
              this.dataActive = "Inactive";
            }
            this.dataExport.push({
              name: element.name,
              serial_id: element.serial_id,
              type: element.type,
              network: element.network,
              location: element.location,
              active: this.dataActive,
              signal: "100",
              bat: "100",
            });
          });
          console.log("Uh oh.");
          break;
        case "Gateway":
          this.dataList.forEach((element) => {
            if (element.active == true) {
              this.dataActive = "Active";
            } else {
              this.dataActive = "Inactive";
            }
            this.dataExport.push({
              name: element.name,
              serial_id: element.serial_id,
              type: element.type,
              network: element.network,
              location: element.location,
              active: this.dataActive,
              signal: element.signal,
            });
          });
          console.log("A good day for golf!");
          break;
        //   case "Alert":
        //   var tempData = "";
        //   this.dataList.forEach((element) => {
        //     element.lastdata.forEach((data) => {
        //       Object.keys(data).forEach((key) => {
        //         tempData += key + " " + data[key] + " ";
        //       });
        //       if (element.alertstatus == true) {
        //         this.dataActive = "Armed";
        //       } else {
        //         this.dataActive = "Disarmed";
        //       }
        //       this.dataExport.push({
        //         alertname: element.alertname,
        //         message: element.message,
        //         sensorname: element.sensorname,
        //         alertname: element.alertname,
        //         lastdata: tempData,
        //         message: element.message,
        //         timestamp: element.timestamp,
        //         status: this.dataActive,
        //       });
        //       tempData = "";
        //     });
        //   });
        //   console.log("A good day for golf!");
        //   break;
        case "Active Users":
          this.dataList.forEach((element) => {
            this.dataExport.push({
              name: element.name,
              username: element.username,
              email: element.email,
              line: element.line,
              islogin: element.islogin,
              status: element.status,
            });
          });
          break;
        case "Inactive Users":
          this.dataList.forEach((element) => {
            this.dataExport.push({
              name: element.name,
              username: element.username,
              email: element.email,
              line: element.line,
              islogin: element.islogin,
              status: element.status,
            });
          });
          break;
        case "Pending Users":
          this.dataList.forEach((element) => {
            this.dataExport.push({
              name: element.name,
              username: element.username,
              email: element.email,
              line: element.line,
              islogin: element.islogin,
              status: element.status,
            });
          });
          break;
        case "Network":
          this.dataList.forEach((element) => {
            this.dataExport.push({
              name: element.name,
              gateway: element.gateway,
              sensors: element.sensors,
            });
          });
          console.log(this.dataExport);
          console.log("A good day for golf!");
          break;
        case "Work Order":
          this.dataList.forEach((element) => {
            this.dataExport.push({
              Work_ID: element.id,
              name: element.name,
              asset: element.asset,
              work_order: element.detail,
              creator: "creator",
              start_date: element.plandate,
              actual_start_date: element.startdate,
              end_date: element.duedate,
              actual_end_date: element.finishtime,
              time_spend: element.timespent,
              percent: element.timespent,
              status: element.iscomplete,
            });
          });
          console.log(this.dataExport);
          console.log("A good day for golf!");
          break;
        case "Part":
          this.dataList.forEach((element) => {
            // let arr2 = "";
            // element.asset.forEach((a) => {
            //   console.log(a, "log");
            //   arr2 += a + ",";
            // });
            this.dataExport.push({
              Name: element.name,
              // Asset: arr2,
              Asset: "Factory",
              Category: element.category,
              Location: element.location,
              // Open_Pos: element.openpos,
              Part_Name: element.partname,
              Part_Number: element.partnumber,
              Price: element.price,
              Qty: element.qtycurrent,
              Vendor: element.vendor,
            });
          });
          break;
        case "WorkOrder":
          this.dataList.forEach((element) => {
            this.dataExport.push({
              Name: element.Name,
              Date: element.Date,
              Assignee: element.Assignee,
            });
          });
          break;
        case "Event":
          this.dataList.forEach((element) => {
            this.dataExport.push({
              Name: element.Name,
              Date: element.Date,
              Assignee: element.Assignee,
            });
          });
          break;
        case "RFID":
          console.log(this.dataList);
          this.dataList.forEach((element) => {
            // console.log(element);
            this.dataExport.push({
              ID: element.id,
              Tag: element.tag,
              Name: element.name,
              Status: element.status == "🔴 Absent" ? "Absent" : "Present",
              Department: element.dept,
            });
          });
          break;
       
        default:
          console.log("Try looking up for a hint.");
      }
      const dataWS = XLSX.utils.json_to_sheet(this.dataExport);
      const wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, dataWS);
      XLSX.writeFile(wb, "export" + this.headerName + ".xlsx");
      this.dataExport = [];
      this.dataActive = "";
    },
  },
};
</script>

<style>
</style>